// 社区管理路由
export default {
    path: 'dynamic',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '社区管理'},
    children: [
        //举报管理
        {
            path: 'accusation',
            component: () => import('@/components/RouterView'),
            redirect: '/dynamic/accusation',
            meta: { title: '举报管理'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/dynamic/accusation'),
                    meta: {title: '举报管理列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/dynamic/accusation/edit'),
                    meta: {title: '举报处理'},
                    props: true
                },
            ]
        },
        //动态管理
        {
            path: 'article',
            component: () => import('@/components/RouterView'),
            redirect: '/dynamic/article',
            meta: { title: '动态管理'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/dynamic/article'),
                    meta: {title: '动态管理列表'}
                },
                {
                    path: 'add',
                    component: () => import('@/views/dynamic/article/add'),
                    meta: {title: '发布动态'}
                },
                {
                    path: 'review/:id',
                    component: () => import('@/views/dynamic/article/review'),
                    meta: {title: '动态评论'},
                    props: true
                }
            ]
        },
        //评论管理
        {
            path: 'review',
            component: () => import('@/components/RouterView'),
            redirect: '/dynamic/review/list',
            meta: { title: '评论管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/dynamic/review/list'),
                    meta: {title: '评论管理列表'}
                },
                {
                    path: 'detail/:id',
                    component: () => import('@/views/dynamic/review/detail'),
                    meta: {title: '评论详情'},
                    props: true
                },
            ]
        },
        // 话题管理
        {
            path: 'topic',
            component: () => import('@/components/RouterView'),
            redirect: '/dynamic/topic',
            meta: { title: '话题管理'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/dynamic/topic'),
                    meta: {title: '话题管理'}
                }
            ]
        },
		//一起看现场
		{
		    path: 'together',
		    component: () => import('@/components/RouterView'),
		    redirect: '/dynamic/together',
		    meta: { title: '一起看现场'},
		    children: [
		        {
		            path: '',
		            component: () => import('@/views/dynamic/together'),
		            meta: {title: '一起看现场'}
		        }
		    ]
		},
        //照片管理
        {
            path: 'photo',
            component: () => import('@/components/RouterView'),
            redirect: '/dynamic/photo/list',
            meta: { title: '照片管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/dynamic/photo/list'),
                    meta: {title: '照片列表'}
                },
                {
                    path: 'allPhoto/:id',
                    component: () => import('@/views/dynamic/photo/allPhoto'),
                    meta: {title: '全部照片'},
                    props: true
                },
                {
                    path: 'orderList/:id',
                    component: () => import('@/views/dynamic/photo/orderList'),
                    meta: {title: '销售明细'},
                    props: true
                },
                {
                    path: 'tags/:id',
                    component: () => import('@/views/dynamic/photo/tags'),
                    meta: {title: '标签管理'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/dynamic/photo/list/add.vue'),
                    meta: {title: '上传照片'},
                }
            ]
        },
        //社群管理
        {
            path: 'chatGroup',
            component: () => import('@/components/RouterView'),
            redirect: '/dynamic/chatGroup/list',
            meta: { title: '群组管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/dynamic/chatGroup/list'),
                    meta: {title: '群组列表'}
                },
                {
                    path: 'rules',
                    component: () => import('@/views/dynamic/chatGroup/rules'),
                    meta: {title: '自动建群规则'}
                }
            ]
        },
    ]
};
